import { createNode, InstantDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromInstant } from '../../utils/temporal';

export const NowInstant = createNode({
    id: 'Now (Instant)',
    name: 'Now (Instant)',
    description: 'Returns the current instant in time as epoch milliseconds',
    aiDescription: 'Takes no inputs and outputs the current Instant on the "Instant" port, representing the exact current moment in time.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {},
    outPorts: {
        Instant: InstantDataType,
    },
    execute: function () {
        const instant = Temporal.Now.instant();
        return { output: { Instant: fromInstant(instant) } };
    },
});
